import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initAnalytics } from './lib/analytics';
import { refreshSession } from './lib/auth';
import { syncSortPreference } from './lib/sortPreference';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

initAnalytics();
void refreshSession().then(() => syncSortPreference());

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
